import React from "react";
import { YahooContent } from "../yahoo/YahooContent";

export function AdContent() {
  return <YahooContent />;
}
